<template>
  <div class="page-width-warpper">
    <div class="news-warpper">
      <div style="width: 280px">
        <Wapper title="热门产品" :more="false">
          <ul class="news">
            <li v-for="(item, i) in hotList" :key="i" @click="toDetail(item)">
              <img :src="item.icon" />
              <div style="flex: 1">
                <div class="name">{{ item.title }}</div>
                <div class="time">更新：{{ item.createTime }}</div>
              </div>
            </li>
          </ul>
        </Wapper>
      </div>
      <div style="flex: 1">
        <div class="newsDetail">
          <div class="title">{{ pageData.title }}</div>
          <div class="time">
            时间：{{ pageData.createTime }} 点击：{{ pageData.cmsViewNum }}次
          </div>
          <div class="info" v-if="pageData.content">
            <div v-html="pageData.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Wapper from "./home/components/Wapper.vue";
import { pageByCode, newsDetail } from "@/api/index";

export default {
  name: "NewsDetail",
  components: {
    Wapper,
  },
  data() {
    return {
      hotList: [],
      pageData: {},
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.getData(val.query.id);
      },
    },
  },
  created() {
    // this.getData(this.$route.query.id);
    pageByCode({ pageNum: 1, pageSize: 10, code: "product_display" }).then(
      (res) => {
        this.hotList = res.data && res.data.records;
      }
    );
  },
  methods: {
    getData(id) {
      newsDetail(id).then((res) => {
        this.pageData = res.data;
      });
    },
    toDetail(item) {
      this.$router.push(`/productDetail?id=${item.id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.news-warpper {
  display: flex;
  padding: 12px 0;
  .news {
    margin-top: 6px;
    padding: 0 4px;
    li {
      display: flex;
      align-items: center;
      line-height: 24px;
      font-size: 12px;
      position: relative;
      margin-bottom: 12px;
      cursor: pointer;
      &:last-child {
        margin: 0;
      }
      &:hover {
        img {
          transform: scale(1.1);
        }
        .name {
          color: $main-color;
          text-decoration: underline;
        }
      }
      img {
        width: 124px;
        height: 82px;
        object-fit: cover;
        display: block;
        margin-right: 12px;
        transition: all 0.5s;
      }
      .name {
        color: #555;
        cursor: pointer;
        @include clamp(2);
      }
      .time {
        margin-top: 5px;
        color: #888;
      }
    }
  }
}
.newsDetail {
  border: 1px solid #ddd;
  margin-left: 12px;
  .title {
    text-align: center;
    font-size: 16px;
    color: $main-color;
    font-weight: bold;
    padding: 20px 20px 0;
  }
  .time {
    text-align: center;
    color: #666;
    font-size: 12px;
    padding: 10px 0;
  }
  .info {
    padding: 5px 10px;
    ::v-deep img {
      max-width: 100%;
    }
  }
}
</style>
